import axiosInstance from "../app/axios";

export const getAdminServiceTypeByServiceTypeId = async (
  serviceTypeId: number,
) => {
  const result = await axiosInstance.get(`admin/servicetype/${serviceTypeId}`);
  return result.data.data;
};

export const addAdminServiceTypes = async (
  serviceTypeId: number,
  adminIds: Array<number>,
) => {
  const result = await axiosInstance.post(
    `admin/servicetype/${serviceTypeId}`,
    { adminIds },
  );
  return result.data;
};

export const getDeactivatedAdminServiceTypeByServiceTypeId = async (
  serviceTypeId: number,
) => {
  const result = await axiosInstance.get(
    `admin/servicetype/deactivated/${serviceTypeId}`,
  );
  return result.data.data;
};

export const deactivateAdminServiceTypes = async (
  serviceTypeId: number,
  adminIds: Array<number>,
) => {
  const result = await axiosInstance.post(
    `admin/servicetype/deactivate/${serviceTypeId}`,
    { adminIds },
  );
  return result.data;
};
